// extracted by mini-css-extract-plugin
export var quantityInput = "_o1-0";